import React from 'react';
import PropTypes from 'prop-types';

const StorySelection = ({ template, onSelectStory, onBack }) => {
  if (!template) {
    return (
      <div className="max-w-4xl mx-auto p-8 bg-white rounded-xl shadow-lg">
        <h2 className="text-xl font-bold text-red-500">
          No story template available
        </h2>
        <p className="mt-2">
          Please select a story style first.
        </p>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center mb-12">
        <button
          onClick={onBack}
          className="mb-8 inline-flex items-center text-gray-600 hover:text-gray-900"
        >
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back to Styles
        </button>

        <div className="flex items-center justify-center mb-6">
          <span className="text-4xl mr-4">{template.emoji}</span>
          <h1 className="text-4xl font-extrabold text-gray-900">
            {template.title}
          </h1>
        </div>

        <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
          {template.subtitle}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {template.example_stories.map((story, index) => (
          <div
            key={index}
            className="group relative bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
            onClick={() => onSelectStory(story.title)}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-yellow-50 to-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

            <div className="relative p-6">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                {story.title}
              </h2>

              <p className="text-gray-600 mb-4">
                {story.description}
              </p>

              <div className="mt-6 flex justify-center">
                <button className="px-6 py-2 bg-yellow-400 text-gray-900 rounded-full font-medium hover:bg-yellow-500 transition-colors duration-300 transform group-hover:scale-105">
                  Read Story
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

StorySelection.propTypes = {
  template: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    emoji: PropTypes.string.isRequired,
    example_stories: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired
      })
    ).isRequired
  }),
  onSelectStory: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired
};

export default StorySelection;